// frontend/src/hooks/useApi.js
import { useState, useEffect } from 'react';

/**
 * Custom hook for API data fetching with loading and error states
 */
export const useApi = (apiFunction, dependencies = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiFunction();
      setData(response.data);
    } catch (err) {
      setError(err.message || 'An error occurred');
      console.error('API Hook Error:', err);
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  fetchData();
}, dependencies);

  return { data, loading, error, refetch: fetchData };
};

export default useApi;